class SliderDirective {
  static directive($document) {
    'ngInject';
    return {
      transclude: true,
      restrict: 'A',
      template: `
        <div class="scroll-container" md-swipe-left="scrollRight()" md-swipe-right="scrollLeft()">
          <a class="scroll-left btn" ng-show="scrollPosition > 0" ng-click="scrollLeft()"></a>
          <ng-transclude></ng-transclude>
    
          <a class="scroll-right btn" ng-hide="disableRight" ng-click="scrollRight()"></a>
        </div>
      `,
      controller: function($scope, $timeout) {
        'ngInject';

        let scrollEl;
        $scope.scrollPosition = 0;
        $scope.scrollRight = function() {
          scrollEl = document.querySelector('.resource-container');
          $scope.scrollPosition = scrollEl.scrollLeft + scrollEl.offsetWidth - 50;

          if($scope.scrollPosition <= scrollEl.scrollLeft + scrollEl.offsetWidth) {
            animate(scrollEl.scrollLeft, $scope.scrollPosition, 1000);
          }
        };
        $scope.scrollLeft = function() {
          scrollEl = document.querySelector('.resource-container');
          $scope.scrollPosition = scrollEl.scrollLeft - scrollEl.offsetWidth + 50;

          if($scope.scrollPosition <= 0) {
            $scope.scrollPosition = 0;
          }

          animate(scrollEl.scrollLeft, $scope.scrollPosition, 1000);
        };

        let easeInQuad = function (x, t, b, c, d) {
          return c*(t/=d)*t + b;
        };

        let animate = function (start, end, duration) {
          let delta = end - start;
          let startTime;
          let w = document.querySelector('.resource-container');
          if (window.performance && window.performance.now) {
            startTime = window.performance.now();
          }
          else if (Date.now) {
            startTime = Date.now();
          }
          else {
            startTime = new Date().getTime();
          }
          let animateLoop = function (time) {
            let t = (!time ? 0 : time - startTime);
            let factor = easeInQuad(null, t, 0, 1, duration);
            w.scrollLeft = start + delta * factor;
            if (t < duration && w.scrollLeft != end) {
              window.requestAnimationFrame(animateLoop);
            }
          };
          animateLoop();

          $timeout(function() {
            $scope.disableRight = w.scrollLeft + w.offsetWidth >= w.scrollWidth;
          }, 1000);
        };
      }
    };
  }
}

export default SliderDirective.directive;



// WEBPACK FOOTER //
// ./src/commons/slider.directive.js